import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <p className="footer-text">
      This project was coded by Laura Vavasseur and is hosted on Netlify
    </p>
  );
}
